import React from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./GridConfig";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import StatusBar from '@dataGrid/components/StatusBar';
import { withAppConfig } from "../../../../../../../appConfigContext";

class EquipmentDefects extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig({
      showTrailerScac: this.props.configJSON.showTrailerScac,
      userConfig: this.props.userData.userProfile?.columnPref,
    });
  }


  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      this.props.gridApi.onFilterChanged
    );
  };

  constructStatusBar = (filteredData) => {
    const statusBarData = [
      {
        label: filteredData.length + " Total Defects",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  render() {
    const {
      equipmentDefectsData = [],
      classes,
      quickFilterText,
      showLoader,
    } = this.props;

    return (
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowData={showLoader ? null : equipmentDefectsData}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
              filterGridData={this.updateGridData}
            />
          )}
          quickFilterText={quickFilterText}
          onGridReady={this.props.onGridReady}
          showErrorMessage={this.props.gridErrorMessage}
        />
      </div>
    );
  }
}
export default compose(
  withUserProfile,
  withAppConfig,
  withSnackbar,
  withStyles(styles)
)(EquipmentDefects);
